<template>
  <div class="page-main">
    <div class="page-top">
      <div class="flex flex-y-center">
        <span class="m-r-5">所属仓库</span>
        <el-select
          v-model="searchWarehouseId"
          size="mini"
          style="width: 200px"
          placeholder="全部仓库"
          filterable
          clearable
          @change="getListData"
        >
          <el-option v-for="item in warehouseOptions" :key="item.val" :label="item.key" :value="item.val" />
        </el-select>
        <span class="m-l-20 m-r-5">关键字</span>
        <el-input
          v-model="keyword"
          size="mini"
          style="width: 200px"
          placeholder="仓位名称/编码/备注"
          clearable
        />
      </div>
      <el-button type="success" size="mini" @click="itemDo()">新增仓位</el-button>
    </div>

    <!-- 表格 -->
    <vxe-grid ref="refTable" v-bind="tableOptions">
      <template #default_warehouse_name="{ row }">
        {{ warehouseName(row.warehouse_id) }}
      </template>
      <template #default_location_type="{ row }">
        {{ locationTypeText(row.location_type) }}
      </template>
      <template #default_status="{ row }">
        <span :class="statusClass(row.status)">{{ statusText(row.status) }}</span>
      </template>
      <template #default_operate="{ row }">
        <el-link type="primary" @click="itemDo(row)">编辑</el-link>
        <el-link type="danger" @click="itemDelete(row)">删除</el-link>
      </template>

      <!-- slot_pager -->
      <template #pager>
        <div></div>
        <vxe-pager v-bind="tableOptions.pagerConfig" @page-change="pageChange" />
      </template>
    </vxe-grid>

    <!-- 弹窗-增改仓位 -->
    <PopupDo
      v-if="isShowPopupDo"
      :show.sync="isShowPopupDo"
      :id="detailId"
      :warehouse-options="warehouseOptions"
      @success="getListData"
    />
  </div>
</template>

<script>
export default {
  components: {
    PopupDo: () => import('../common/popup-do')
  },
  data() {
    return {
      keyword: '',
      searchWarehouseId: '',
      warehouseList: [],
      allData: [],
      tableOptions: {
        loading: false,
        size: 'mini',
        border: true,
        height: this.$util.getViewHeight() - 36 - 148,
        pagerConfig: {
          currentPage: 1,
          pageSize: 20,
          total: 0,
          pageSizes: [10, 20, 50, 100]
        },
        columns: [
          { fixed: 'left', title: '序号', type: 'seq', width: 50 },
          { field: 'location_code', title: '仓位编码', width: 160 },
          { field: 'location_name', title: '仓位名称', minWidth: 140 },
          { field: 'warehouse_id', title: '所属仓库', width: 160, slots: { default: 'default_warehouse_name' } },
          { field: 'location_type', title: '仓位类型', width: 100, slots: { default: 'default_location_type' } },
          { field: 'status', title: '状态', width: 80, slots: { default: 'default_status' } },
          { field: 'remark', title: '备注', minWidth: 160 },
          { title: '操作', fixed: 'right', width: 120, slots: { default: 'default_operate' } }
        ],
        data: []
      },
      isShowPopupDo: false,
      detailId: ''
    }
  },
  computed: {
    warehouseOptions() {
      return this.warehouseList.map((item) => ({ key: item.warehouse_name, val: item.id }))
    }
  },
  watch: {
    keyword() {
      this.tableOptions.pagerConfig.currentPage = 1
      this.refreshView()
    }
  },
  async mounted() {
    await this.getWarehouseList()
    this.getListData()
  },
  methods: {
    warehouseName(id) {
      const wh = this.warehouseList.find((w) => w.id === id)
      return wh ? wh.warehouse_name : ''
    },
    locationTypeText(val) {
      const map = { 1: '货架位', 2: '地堆', 3: '暂存区', 4: '退货区', 5: '待检区' }
      return map[Number(val)] || ''
    },
    statusText(val) {
      const map = { 1: '启用', 0: '停用', 2: '锁定' }
      return map[Number(val)] || ''
    },
    statusClass(val) {
      const st = Number(val)
      if (st === 1) return 'c-green'
      if (st === 2) return 'c-orange'
      return 'c-red'
    },
    getWarehouseList() {
      return this.$api({
        method: 'post',
        url: '/admin/gcvip/newWarehouse/list',
        data: { currentPage: 1, pageSize: this.$constant.pageMax, sortData: 'id desc' }
      })
        .then((res) => {
          if (res.status === 200 && res.data.page) {
            this.warehouseList = res.data.page.list || []
          }
        })
        .catch(() => {})
    },
    getListData() {
      this.tableOptions.loading = true
      const data = { currentPage: 1, pageSize: this.$constant.pageMax, deleted: false, sortData: 'id desc' }
      if (this.searchWarehouseId) data.warehouseId = this.searchWarehouseId
      this.$api({
        method: 'post',
        url: '/admin/gcvip/warehouseLocation/list',
        data
      })
        .then((res) => {
          if (res.status === 200 && res.data.page) {
            this.allData = res.data.page.list || []
            this.tableOptions.pagerConfig.currentPage = 1
            this.refreshView()
          }
        })
        .catch(() => {})
        .then(() => {
          this.tableOptions.loading = false
        })
    },
    filteredData() {
      const kw = (this.keyword || '').trim().toLowerCase()
      if (!kw) return this.allData
      return this.allData.filter((row) => {
        const fields = [row.location_name, row.location_code, row.remark]
        return fields.some((f) => f && String(f).toLowerCase().includes(kw))
      })
    },
    refreshView() {
      const list = this.filteredData()
      const { currentPage, pageSize } = this.tableOptions.pagerConfig
      this.tableOptions.pagerConfig.total = list.length
      const start = (currentPage - 1) * pageSize
      this.tableOptions.data = list.slice(start, start + pageSize)
    },
    pageChange({ currentPage, pageSize }) {
      this.tableOptions.pagerConfig.currentPage = currentPage
      this.tableOptions.pagerConfig.pageSize = pageSize
      this.refreshView()
    },
    itemDo(row) {
      this.detailId = row === undefined ? '' : row.id
      this.isShowPopupDo = true
    },
    itemDelete(row) {
      this.$confirm('您确认要删除该仓位?', '提示')
        .then(() => {
          this.$api({
            method: 'get',
            url: '/admin/gcvip/warehouseLocation/delete',
            params: { id: row.id }
          }).then((res) => {
            if (res.data.state !== 'fail') {
              this.$message.success('删除成功')
              this.getListData()
            }
          })
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
  .page-top {
    position: relative;
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }
}
</style>
